import { __awaiter } from "tslib";
export const checkNoAdsRule = (rule) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    return rule.value === ((_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.ads) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.opts) === null || _c === void 0 ? void 0 : _c.noAdsReasons) === null || _d === void 0 ? void 0 : _d.length) > 0;
});
export const validateNoAdsRule = (rule) => {
    // value needs to be present
    return !!rule.value;
};
